import {
  IEventBracketSummary,
  IPublishedBracketSummary,
  IUserRegistrationBracket
} from '../../../../../types/eventBracketTypes';
import {
  IEventRegistrationDetails,
  IEventRegistrationUserStepData,
  IEventUserRegistrationStepSummary,
  IPublicRelatedEvent,
  IPublishedEventSummary,
  RegistrationStepOptionMode,
  TMultiRegistrationEventFormItem,
  TRegistrationStepOptionLabel
} from '../../../../../types/eventTypes';

export type TEventRegistrationDetailsState = {
  isLoading: boolean;
  isLoaded: boolean;
  details: IEventRegistrationDetails | null;
  ui: Record<string, string>;
};

export type TEventBracketDetailsState = {
  isLoading: boolean;
  isLoaded: boolean;
  details: IPublishedBracketSummary | null;
  isRefreshing: boolean;
  ui: Record<string, string>;
};

export type TEventBracketListState = {
  isLoading: boolean;
  isLoaded: boolean;
  list: IEventBracketSummary[];
  relatedEvents: IPublicRelatedEvent[];
  ui: Record<string, string>;
};

export type TDynamicEventBracketDetailsState = {
  isLoading: boolean;
  isLoaded: boolean;
  bracket: IPublishedBracketSummary | null;
  error?: unknown;
};

export type TDynamicEventBracketStateItem = {
  event: IPublishedEventSummary | null;
  isLoading: boolean;
  isLoaded: boolean;
  error?: unknown;
  brackets: {
    // ${bracketSlug}
    [key: string]: TDynamicEventBracketDetailsState;
  };
};

export type TEventReminderListState = {
  isLoading: boolean;
  isRefreshing: boolean;
  isLoaded: boolean;
  list: IUserRegistrationBracket[];
  ui: Record<string, string>;
};

export type TEventTeamListStateUI = {
  eventSlug?: string;
  count: number;
  page: number;
  pageSize: number;
  minTeamSize: number | null;
  maxTeamSize: number | null;
  search: string;
};

export type TEventTeamListState = {
  isLoading: boolean;
  isLoaded: boolean;
  list: any[];
  ui: TEventTeamListStateUI;
};

export type TEventRegistrationStepFormItemValue = {
  value: any;
  mode: RegistrationStepOptionMode;
  errors: string[];
};

export type TEventRegistrationStepFormItemData = Record<
  TRegistrationStepOptionLabel,
  TEventRegistrationStepFormItemValue
>;

export type TEventRegistrationStepFormItem = IEventUserRegistrationStepSummary & {
  data: TEventRegistrationStepFormItemData;
};

export type TEventRegistrationFormState = {
  eventId: number;
  slug: string;
  registrationSteps: TEventRegistrationStepFormItem[];
  multiRegistrationEvents: TMultiRegistrationEventFormItem[];
};

export type TEventDetailsState = {
  eventRegistrationDetails: TEventRegistrationDetailsState;
  eventTeamList: TEventTeamListState;
  eventReminderList: TEventReminderListState;
  eventBracketList: TEventBracketListState;
  eventRegistrationForm: TEventRegistrationFormState | null;
  requestPending: boolean;
  selectedEventBracketDetails: TEventBracketDetailsState;
  dynamic: {
    [key: string]: TDynamicEventBracketStateItem;
  };
  isCheckingInRequestPending: boolean;
};

export type TEventDetailsPreviewState = {
  eventDetails: TEventDetailsState;
};

export enum ActiveGameMatchMode {
  // Automatically follows the most recently updated match. All matches are considered.
  Follow = 'follow',
  // Scrolls to the furthest progressed match. Only in-progress or completed matches are considered.
  Latest = 'latest'
}

export type TSaveEventUserRegistrationPayload = {
  slug: string;
  data: { steps: IEventRegistrationUserStepData[]; multiRegistrationEvents: TMultiRegistrationEventFormItem[] };
  inviteCode?: string;
};
